import * as moment from 'moment';
import { Moment } from 'moment';

export class LocalLoadNotification {

  public id: string;
  public title: string;
  public message: string;
  public createdBy: string;
  public createdAt: Moment;
  public type: string;

  static fromDto(data: any): LocalLoadNotification {
    if (!data) {
      return null;
    }

    const notification = new LocalLoadNotification();

    notification.id        = data.id;
    notification.title     = data.title;
    notification.message   = data.message;
    notification.createdBy = data.created_by;
    notification.createdAt = data.created_at ? moment(data.created_at) : null;
    notification.type      = data.type;

    return notification;
  }
}
